module.exports = __webpack_public_path__ + "static/media/3132.189108cf.jpg";